
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { City } from "@/models/City";
import AddCity from "./AddCity.vue";
import { orderBy } from "lodash";

@Component({
  components: {
    AddCity,
  },
})
class CitiesTable extends Vue {
  @Prop({ default: false }) readonly isEditing!: boolean;
  items = [];
  searchFilter = "";
  busy = true;
  slug = "";
  fields = [
    {
      key: "name",
      label: "Name",
      sortable: true,
    },
    {
      label: "Country",
      key: "country",
      sortable: true,
    },
  ];

  get getCities(): City[] {
    return orderBy(
      this.$store.state.cityStore.city,
      (o: City) => o.name.en.toLowerCase(),
      "asc"
    );
  }

  created(): void {
    if (this.getCities.length > 0) {
      this.busy = false;
    }
  }

  onRowSelected(rows: any): void {
    if (rows.length < 1) return;
    this.$emit("handleTableSelection", rows[0]);
  }
  filterByCityName(row: City): boolean {
    if (row.name.en.toLowerCase().includes(this.searchFilter.toLowerCase())) {
      return true;
    }
    return false;
  }
  openAddCity(): void {
    this.$bvModal.show("team-modal-add-city");
  }

  @Watch("getCities")
  isLoading(value: City[]): void {
    if (value.length > 0) this.busy = false;
  }
}

export default CitiesTable;
